import { LoaderCircle, Redo2 } from 'lucide-react';
import { Button, InputGroup, InputGroupAddon, Input } from 'twyne-new.ui';

import FormSelect from '@Components/formsy/Select';

export default function Select({ options, onReload, ...props }) {
  return <>
    <InputGroup>
      {options ? <FormSelect {...props}
        validationErrors={{
          isDefaultRequiredValue: "",
        }}
        options={options}
      /> : <Input placeholder='loading' className='font-italic' disabled />}
      <InputGroupAddon>
        {!options ? <LoaderCircle size={16} className='animate-spin' /> : <>
          <Button color='accent' size='sm' onClick={onReload} disabled={!options}>
            <Redo2 size={16} />
          </Button>
        </>}
      </InputGroupAddon>
    </InputGroup>
  </>
}
